var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgRules(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.33333 10.8333C3.79357 10.8333 4.16667 11.2064 4.16667 11.6667V17.5C4.16667 17.9602 3.79357 18.3333 3.33333 18.3333C2.8731 18.3333 2.5 17.9602 2.5 17.5V11.6667C2.5 11.2064 2.8731 10.8333 3.33333 10.8333Z",
    fill: "#D4C8FA"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.33333 1.66666C3.79357 1.66666 4.16667 2.03975 4.16667 2.49999V8.33332C4.16667 8.79356 3.79357 9.16666 3.33333 9.16666C2.8731 9.16666 2.5 8.79356 2.5 8.33332V2.49999C2.5 2.03975 2.8731 1.66666 3.33333 1.66666Z",
    fill: "#D4C8FA"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10 9.16666C10.4602 9.16666 10.8333 9.53975 10.8333 9.99999V17.5C10.8333 17.9602 10.4602 18.3333 10 18.3333C9.53977 18.3333 9.16667 17.9602 9.16667 17.5V9.99999C9.16667 9.53975 9.53977 9.16666 10 9.16666Z",
    fill: "#D4C8FA"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10 1.66666C10.4602 1.66666 10.8333 2.03975 10.8333 2.49999V6.66666C10.8333 7.12689 10.4602 7.49999 10 7.49999C9.53977 7.49999 9.16667 7.12689 9.16667 6.66666V2.49999C9.16667 2.03975 9.53977 1.66666 10 1.66666Z",
    fill: "#D4C8FA"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.6667 12.5C17.1269 12.5 17.5 12.8731 17.5 13.3333V17.5C17.5 17.9602 17.1269 18.3333 16.6667 18.3333C16.2064 18.3333 15.8333 17.9602 15.8333 17.5V13.3333C15.8333 12.8731 16.2064 12.5 16.6667 12.5Z",
    fill: "#D4C8FA"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.6667 1.66666C17.1269 1.66666 17.5 2.03975 17.5 2.49999V9.99999C17.5 10.4602 17.1269 10.8333 16.6667 10.8333C16.2064 10.8333 15.8333 10.4602 15.8333 9.99999V2.49999C15.8333 2.03975 16.2064 1.66666 16.6667 1.66666Z",
    fill: "#D4C8FA"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 11.6667C0 11.2064 0.373096 10.8333 0.833333 10.8333H5.83333C6.29357 10.8333 6.66667 11.2064 6.66667 11.6667C6.66667 12.1269 6.29357 12.5 5.83333 12.5H0.833333C0.373096 12.5 0 12.1269 0 11.6667Z",
    fill: "#D4C8FA"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.66667 6.66668C6.66667 6.20644 7.03977 5.83334 7.50001 5.83334H12.5C12.9602 5.83334 13.3333 6.20644 13.3333 6.66668C13.3333 7.12691 12.9602 7.50001 12.5 7.50001H7.50001C7.03977 7.50001 6.66667 7.12691 6.66667 6.66668Z",
    fill: "#D4C8FA"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.3333 13.3333C13.3333 12.8731 13.7064 12.5 14.1667 12.5H19.1667C19.6269 12.5 20 12.8731 20 13.3333C20 13.7936 19.6269 14.1667 19.1667 14.1667H14.1667C13.7064 14.1667 13.3333 13.7936 13.3333 13.3333Z",
    fill: "#D4C8FA"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRules);
export default __webpack_public_path__ + "static/media/rules.dea687bd.svg";
export { ForwardRef as ReactComponent };